import { render, staticRenderFns } from "./PoOrders.vue?vue&type=template&id=63663190&scoped=true"
import script from "./PoOrders.vue?vue&type=script&lang=js"
export * from "./PoOrders.vue?vue&type=script&lang=js"
import style0 from "./PoOrders.vue?vue&type=style&index=0&id=63663190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63663190",
  null
  
)

export default component.exports